// Module
var code = `<div data-bind="event: { pointerdown: function(model, event) { return onPointerDown(event); } }, attr: attributes, css: getRootCss()">
  <div class="svc-image-item-value-wrapper__ghost" data-bind="style: getNewItemStyle()"></div>

  <div class="svc-image-item-value-wrapper__content">
    <input type="file" aria-hidden="true" tabindex="-1" class="svc-choose-file-input" data-bind="attr: { accept: acceptedTypes }">

    <!-- ko ifnot: isNew || isUploading -->
    <div class="svc-image-item-value__item">
      <!-- ko component: { name: 'sv-template-renderer', params: { componentData: null, templateData: templateData } } -->
      <!-- /ko -->
    </div>

    <!-- ko if: isDraggable && canRenderControls-->
    <sv-svg-icon class="svc-context-button svc-image-item-value-controls__drag-area-indicator" data-bind="event: { pointerdown: function(model, event) { onPointerDown(event); } }" params="iconName: 'icon-drag-24x24', size: 'auto'">
    </sv-svg-icon>
    <!-- /ko -->

    <!-- ko if: canRenderControls-->
    <div class="svc-context-container svc-image-item-value-controls" data-bind="event: { pointerdown: blockEvent }">
      <!-- ko if: allowRemove && !isUploading -->
      <sv-svg-icon class="svc-context-button" data-bind="click: chooseFile, key2click" params="iconName: 'icon-choosefile', size: 'auto', title: selectFileTitle" role="button"></sv-svg-icon>
      <sv-svg-icon class="svc-context-button svc-context-button--danger" data-bind="click: remove, key2click" params="iconName: 'icon-delete', size: 'auto', title: removeFileTitle" role="button"></sv-svg-icon>
      <!-- /ko -->
    </div>
    <!-- /ko -->
    <!-- /ko -->

    <!-- ko if: isNew || isUploading -->
    <div class="svc-image-item-value__item" data-bind="event: { dragover: dragover, drop: drop, dragleave: dragleave }">
      <div class="sd-imagepicker__item sd-imagepicker__item--inline">
        <label class="sd-imagepicker__label">
          <div data-bind="style: getNewItemStyle()" class="sd-imagepicker__image">
            <!-- ko if: isUploading -->
            <div class="svc-image-item-value__loading">
              <!-- ko component: { name: 'sv-loading-indicator' } -->
              <!-- /ko -->
            </div>
            <!-- /ko -->
          </div>
        </label>
      </div>
    </div>

    <div class="svc-image-item-value-controls" data-bind="event: { pointerdown: blockEvent }">
      <!-- ko if: allowAdd && !isUploading -->
      <sv-svg-icon class="svc-context-button svc-image-item-value-controls__add" data-bind="click: chooseNewFile, key2click, clickBubble: false" params="iconName: 'icon-add-lg', size: 'auto', title: addFileTitle">
      </sv-svg-icon>
      <!-- /ko -->
    </div>
    <!-- /ko -->
  </div>
</div>`;
// Exports
export default code;